import React from "react";
import { useFormContext } from "react-hook-form";
import MainButton from "../../../../../../../shared/components/MainButton";
import Text from "../../../../../../../shared/components/Text";

export const AddressComplementFormSubmitter = ({ onSubmitForm }) => {
  const { handleSubmit, getValues } = useFormContext();
  return (
    <MainButton
      variant="contained"
      onClick={handleSubmit(() => onSubmitForm(getValues()))}
    >
      <Text tId="CONTINUE" />
    </MainButton>
  );
};
